const darkMode = {
  namespaced: true,
  state: {
    isDarkMode: false,
    themeText: '系统'
  },
  mutations: {
    SET_DARK_MODE: (state, isDarkMode) => {
      state.isDarkMode = isDarkMode
    },
    SET_THEME_TEXT: (state, themeText) => {
      state.themeText = themeText === 1 ? '浅色' : themeText === 2 ? '深色' : '系统'
    }
  }
}

export default darkMode
